import React from 'react';
import img from '../../../assets/images/seguroViagem.png';
import '../../seguranca/politicas/politicas.css';
import linha from '../../../assets/linha.png';

export default function SeguroViagem() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0 sectionInit">
        <div className="c-init">
          <div className="c-init__text col-6  d-flex flex-column sect mt-5">
            <p className="fw-bolder text-decoration-underline">
              SEGURO VIAGEM – GTA
            </p>
            <p>
              A Ourominas (OM) é parceira da empresa de seguros GTA Seguro Viagem.
            </p>
            <p>
              O Seguro Viagem é um dos seguros mais vendidos no Brasil devido ao
              crescimento do mercado turístico, demostrando assim que as pessoas
              estão mais conscientes em relação a necessidade de adquirir um
              seguro antes de viajar.
            </p>
            <p>
              A relevância do mercado e a alta demanda do segmento incentivou a
              OM e a GTA Seguro Viagem a se unirem para oferecer os melhores planos de
              seguro viagem aos nossos clientes, com os melhores preços e
              condições. Tudo isso para garantir a segurança e tranquilidade de
              milhares de pessoas em suas viagens nacionais ou internacionais.
            </p>
            <div className="div-line">
              <img src={linha} alt="linha de separação"></img>
            </div>
          </div>
          <div className="col-6 c-init__images">
            <img src={img} className="images" alt="grupo-om"></img>
          </div>
        </div>{' '}
        <section>
          <p>
            A Bit Seguros é uma corretora de seguros online, que oferece seguros
            e assistências de maneira fácil e ágil. Desde 2015 atua no mercado
            desenvolvendo produtos e soluções com ideias e tecnologias
            inovadoras, sempre em parceria com as principais seguradoras do
            país. Proporciona aos seus clientes a melhor experiência em seguros
            com um único propósito: oferecer o que há de mais avançado em
            proteção para seus clientes e familiares.
          </p>
        </section>
        <section className="mt-4 sect">
          <p className=" mt-5 my-3  fw-bolder">PERGUNTAS FREQUENTES</p>
          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">O QUE É SEGURO VIAGEM? </summary>
            <p>
              O seguro viagem é um serviço que presta suporte ao viajante,
              garantindo mais tranquilidade em sua viagem caso algum imprevisto
              aconteça.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              POR QUE DEVO CONTRATAR UM SEGURO VIAGEM?{' '}
            </summary>
            <p className="mt-4">
              Contratar um seguro viagem é garantir a tranquilidade e o conforto
              que você merece. O seguro cobre atendimentos médicos, hospitalares
              e odontológicos. Além de oferecer garantias como: indenização em
              caso de extravio de bagagem, cancelamento de viagem e muito mais.
              Vale ressaltar que em alguns países o seguro viagem é obrigatório.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">O QUE É TRATADO DE SCHENGEN?</summary>
            <p className="mt-4">
              O Tratado de Schengen é um acordo entre 26 países europeus, que
              permite a livre circulação de pessoas sem a necessidade de
              apresentação de passaporte nas fronteiras. Um dos requisitos para
              a livre circulação é a obrigatoriedade do seguro viagem, com
              cobertura de despesas médicas e hospitalares, no valor mínimo de
              30.000 euros.
            </p>
            <p>
              Atualmente 26 países fazem parte do Tratado de Schengen, são eles:
              Alemanha, Áustria, Bélgica, Dinamarca, Eslováquia, Eslovênia,
              Espanha, Estônia, Finlândia, França, Grécia, Holanda, Hungria,
              Islândia, Itália, Letônia, Liechtenstein, Lituânia, Luxemburgo,
              Malta, Noruega, Polônia, Portugal, República Tcheca, Suécia,
              Suíça.
            </p>
            <p>
              Além dos países que fazem parte do Tratado de Schengen, países
              como Cuba, Venezuela, Dubai também possuem a obrigatoriedade do
              Seguro Viagem.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              O SEGURO VIAGEM SÓ POSSUI COBERTURA MÉDICA E HOSPITALAR?
            </summary>
            <p className="mt-4">
              Não. O seguro viagem possui 19 coberturas, tais como: Atendimentos
              médicos, hospitalares, odontológicos, despesas farmacêuticas,
              cancelamento de viagem, extravio de bagagens, regresso de menor ou
              idoso desacompanhado, e muito mais.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              COMO É REALIZADO O ATENDIMENTO?
            </summary>
            <p className="mt-4">
              Em caso de imprevistos, você pode entrar em contato com a
              Assistência 24 Horas do seu Seguro Viagem através do 0800 para um
              pronto atendimento em português. Tudo rápido e prático.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">QUANTO CUSTA O SEGURO VIAGEM?</summary>
            <p className="mt-4">
              Contratar um seguro viagem custa bem menos do que o valor de
              apenas um atendimento médico de urgência em países como o Estados
              Unidos, onde um simples atendimento médico pode custar 450 dólares
              e na Europa 300 Euros. Solicite já sua cotação!
            </p>
          </details>
        </section>
      </section>
    </article>
  );
}
